import type { DeepReadonly, Ref, ToRefs } from 'vue'

export interface UseSearch extends DeepReadonly<ToRefs<State>> {
  data: Ref<any[]>
  query(params: QueryOptions): Promise<SearchResults & IncludeType>
  append(): Promise<SearchResults & IncludeType>
}

interface State {
  loading: boolean
  count: number
  lastOptions: any
  type: string
}

export interface QueryOptions {
  type: string
  options: any
  append?: boolean
  updateState?: boolean
}

interface SearchResults {
  count: number
  results: any[]
}

interface IncludeType {
  type: string
}

export function useSearch(): UseSearch {
  const data = ref([] as any[])

  const state = reactive<State>({
    loading: false,
    count: 0,
    lastOptions: {},
    type: '',
  })

  async function query({ type, options, append = false, updateState = true }: QueryOptions) {
    state.loading = true

    if (!append) {
      data.value = []
    }

    const { count, results } = await $fetch<SearchResults>(`/v2/${type}`, {
      ...useFetchSharedOptions(),
      params: { ...options },
    })

    if (updateState) {
      state.lastOptions = options
      state.type = type
      state.count = count
      state.loading = false
      data.value = append ? [...data.value, ...results] : results
    }

    return {
      type,
      count,
      results,
    }
  }

  function append() {
    return query({
      type: state.type,
      append: true,
      options: {
        ...state.lastOptions,
        offset: data.value.length,
      },
    } as QueryOptions)
  }

  return {
    query,
    data,
    append,
    ...toRefs(state),
  }
}
